
export namespace MouseEventTypes {
    export type MouseEventType = 'RESIZE' |
        'MOVE' |
        'ROTATE';
    export const RESIZE: MouseEventType = 'RESIZE';
    export const MOVE: MouseEventType = 'MOVE';
    export const ROTATE: MouseEventType = 'ROTATE';
}

export interface Dimension {
    width: number;
    height: number;
}

export interface Location {
    x: number;
    y: number;
}

export interface Resizable {
    resize(location: Location);
}

export interface Point {
    x: number;
    y: number;
}

export interface Ratio {
    x: number;
    y: number;
}

export interface DirectionalVector {
    x: number;
    y: number;
}

export interface Rectangle extends Dimension2D {
    top: number;
    left: number;
}

export interface Dimension2D {
    width: number;
    height: number;
}
